export default {
  tickersType: null,
  quotes: null,
  currencyExchangeRate: null,
  contributionAmount: null,
  CEIData: null,
  CEIlastSyncDate: null
};
